import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import {
  addAlterarEmpresa,
  addAutoAtendimentoAutoAtendimento,
} from "slices/Empresa/thunk";
import * as Yup from "yup";
import withRouter from "../../Components/Common/withRouter";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import PainelControleListaAutoAtendimento from "./PainelControleListaAutoAtendimento";
import PainelControleListaCliente from "./PainelControleListaCliente";
import { Link } from "react-router-dom";

const PainelControle = () => {
  document.title = "Fila de atendimento :: Painel de controle";
  const dispatch: any = useDispatch();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [registro, setRegistro] = useState<any>({});

  const validationSchema = Yup.object({
    id: Yup.string().optional(),
    nome: Yup.string()
      .required("Nome é obrigatório !")
      .max(255, "Nome deve ter no mínimo 255 caracteres !"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      id: "",
      nome: "",
    },
  });

  useEffect(() => {
    if (registro && isEdit) {
      reset({
        id: registro.id,
        nome: registro.nome,
      });
    }
  }, [registro, reset, isEdit]);

  const onSubmit = async (data: any) => {
    if (isEdit) {
      const result = await dispatch(addAlterarEmpresa(data));
      if (result.payload.name === undefined) {
        reset({
          id: "",
          nome: "",
        });
        setIsEdit(false);
      }
    } else {
      const result = await dispatch(
        addAutoAtendimentoAutoAtendimento({ nome: data.nome })
      );
      if (result.payload.name === undefined) {
        reset({
          id: "",
          nome: "",
        });
        setIsEdit(false);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <ParticlesAuth>
          <Container fluid>
            <Row>
              <div className="flex-grow-1" style={{ textAlign: "center" }}>
                <h2>Controle de atendimento</h2>
              </div>
              <div className="hstack justify-content-center">
                <Link to="/impressao">
                  <button
                    type="submit"
                    className="btn btn-warning"
                    id="add-btn"
                  >
                    <i className={"bx bx-printer"}></i> Ver todos
                  </button>
                </Link>
              </div>
            </Row>
            <Row>
              <Col xl={6}>
                <Form
                  noValidate
                  autoComplete="off"
                  className="tablelist-form"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Row className="mb-3">
                    <Col lg={2}></Col>
                    <Col lg={6}>
                      <Label for="nome" className="form-label">
                        Atendimento Manual
                      </Label>
                      <Controller
                        name="nome"
                        control={control}
                        render={({ field }) => (
                          <Input
                            {...field}
                            maxLength={255}
                            type="text"
                            className="form-control"
                            value={field.value || ""}
                            onChange={(e) => field.onChange(e.target.value)}
                            invalid={!!errors.nome}
                            placeholder="Insira o nome da empresa"
                          />
                        )}
                      />
                      {errors.nome && (
                        <FormFeedback>{errors.nome.message}</FormFeedback>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3}></Col>
                    <Col lg={4}>
                      <div className="hstack justify-content-center">
                        <button
                          type="submit"
                          className="btn btn-success"
                          id="add-btn"
                        >
                          {isEdit ? "Alterar" : "Inserir"}
                        </button>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <PainelControleListaCliente
                      setIsEdit={setIsEdit}
                      registro={registro}
                      setRegistro={setRegistro}
                    ></PainelControleListaCliente>
                  </Row>
                </Form>
              </Col>
              <Col xl={6}>
                <Row className="mb-3" style={{ paddingTop: 106 }}></Row>
                <PainelControleListaAutoAtendimento
                  setIsEdit={setIsEdit}
                  registro={registro}
                  setRegistro={setRegistro}
                ></PainelControleListaAutoAtendimento>
              </Col>
            </Row>
          </Container>
        </ParticlesAuth>
      </div>
    </React.Fragment>
  );
};

export default withRouter(PainelControle);
